import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { useParams, useLocation } from 'react-router-dom'
import io from 'socket.io-client'
import { message } from 'antd'
import { apiBaseURL, socketURL } from '../config'

export default function MpChat() {
  const { contactId } = useParams()
  const location = useLocation()
  const [senderId, setSenderId] = useState(localStorage.getItem('uuid') || '')
  const [messages, setMessages] = useState([])
  const [contact, setContact] = useState({})
  const [enlargedImage, setEnlargedImage] = useState(null)
  const [socket, setSocket] = useState(null)
  const messagesEndRef = useRef(null)

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const code = searchParams.get('code')

    axios.post('/c/kf_c/weixinmp/login', {
      code: code,
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setSenderId(response.data.oid)

          axios.post('/c/kf_c/chat_history/get', {
            identity: senderId,
            contact_id: contactId,
          })
            .then(function (response) {
              if (response.errcode === 0) {
                setMessages(response.data.records)
              } else {
                message.warning(response.msg)
              }
            })
            .catch(function (error) {
              console.error('请求失败，错误信息为：', error)
            })
          axios.post('/c/kf_c/kefu/detail/get', {
            account_oid: contactId,
            })
              .then(function (response) {
                if (response.errcode === 0) {
                  setContact(response.data)
                } else {
                  message.warning(response.msg)
                }
              })
              .catch(function (error) {
                console.error('请求失败，错误信息为：', error)
              })
        } else {
          message.warning(response.msg)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [location.search, senderId, contactId])


  useEffect(() => {
    if (senderId) {
      const socketConnection = io(socketURL, {
        query: {
          identity: senderId,
        },
      })
      setSocket(socketConnection)
  
      socketConnection.on('json', (newMessage) => {
        setMessages((prevMessages) => [...prevMessages, { ...newMessage, sender: 'received' }])
      })
  
      return () => {
        if (socketConnection) {
          socketConnection.disconnect()
        }
      }
    }
  }, [contactId, senderId])

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'auto' })
    }
  }, [messages])

  const handleSendMessage = (content, type = 'text') => {
    if (!content.trim() && type === 'text') return
    const newMessage = {
      content: content,
      sender: 'sent',
      senderId: senderId,
      receiverId: contactId,
      type,
      time: new Date().toISOString(),
    }
    setMessages((prevMessages) => [...prevMessages, newMessage])

    if (socket) {
      socket.emit('json', newMessage)
    }
  }

  const handleImageUpload = (e) => {
    const file = e.target.files[0]
    const formData = new FormData()
    formData.append('image', file)

    if (file) {
      axios.post(`${apiBaseURL}/common/image/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(function (response) {
          if (response.errcode === 0) {
            handleSendMessage(response.data.image_url, 'image')
          } else {
            message.warning(response.data.msg)
          }
        })
        .catch(function (error) {
          console.error('请求失败，错误信息为：', error)
        })
    }
  }

  const handleImageClick = (imageSrc) => {
    setEnlargedImage(imageSrc)
  }

  const handleCloseEnlargedImage = () => {
    setEnlargedImage(null)
  }

  const formatMessageTime = (timestamp) => {
    if (!timestamp) {
      return '未知时间'
    }

    const now = new Date()
    const messageDate = new Date(timestamp)

    if (isNaN(messageDate.getTime())) {
      return '未知时间'
    }

    const isToday = now.toDateString() === messageDate.toDateString()
    const isYesterday = new Date(now.setDate(now.getDate() - 1)).toDateString() === messageDate.toDateString()
    const isThisYear = now.getFullYear() === messageDate.getFullYear()

    if (isToday) {
      return messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    } else if (isYesterday) {
      return `昨天 ${messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
    } else if (isThisYear) {
      return `${messageDate.getMonth() + 1}-${messageDate.getDate()} ${messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
    } else {
      return `${messageDate.getFullYear()}-${messageDate.getMonth() + 1}-${messageDate.getDate()} ${messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
    }
  }

  return (
    <div className="chat-page">
      <div className="chat-window">
        <div className="chat-header">
          <img src={contact.avatar} alt='' />
          <span>{contact.nickname}</span>
        </div>

        <div className="chat-messages">
          {messages.map((message, index) => {
            const currentTime = new Date(message.time).getTime()
            const prevTime = index > 0 ? new Date(messages[index - 1].time).getTime() : null
            const showTime = !prevTime || (currentTime - prevTime) > 5 * 60 * 1000

            return (
              <React.Fragment key={index}>
                {showTime && (
                  <div className="message-time">
                    {formatMessageTime(message.time)}
                  </div>
                )}

                {message.type === 'text' ? (
                  <div className={`message ${message.sender}`}>
                    <span>{message.content}</span>
                  </div>
                ) : (
                  <img
                    src={message.content}
                    alt="sent"
                    className={`chat-image ${message.sender === 'sent' ? 'sent-image' : 'received-image'}`}
                    onClick={() => handleImageClick(message.content)}
                    onLoad={() => {
                      if (messagesEndRef.current) {
                        messagesEndRef.current.scrollIntoView({ behavior: 'smooth' })
                      }
                    }}
                  />
                )}
              </React.Fragment>
            )
          })}
          <div ref={messagesEndRef} />
        </div>

        <div className="chat-input">
          <div className="chat-input-upload">
            <label htmlFor="file-upload">
              <img src="/images/upload.png" alt="上传图片" />
              <input
                id="file-upload"
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleImageUpload}
              />
            </label>
          </div>

          <textarea
            className="chat-input-textarea desktop"
            placeholder="输入"
            enterKeyHint="send"
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault()
                handleSendMessage(e.target.value)
                e.target.value = ''
              }
            }}
          />
          <input
            className="chat-input-textarea mobile"
            placeholder="输入"
            enterKeyHint="send"
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault()
                handleSendMessage(e.target.value)
                e.target.value = ''
              }
            }}
          />
        </div>
      </div>

      {enlargedImage && (
        <div className="image-modal" onClick={handleCloseEnlargedImage}>
          <img src={enlargedImage} alt="enlarged" className="enlarged-image" />
        </div>
      )}
    </div>
  )
}